import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Alert,
	Box
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { showTabCloseModal } from "../../../../state/actions/modal";
import { useDispatch } from "react-redux";

const ButtonPrimary = styled(Button)({
	color: "#f50057",
	backgroundColor: "#f8bbd0",
});

const ButtonSecondary = styled(Button)({
	color: "#00a7d6",
	backgroundColor: "#bbdefb",
});

const StyledAlert = styled(Alert)({
	"& .MuiAlert-icon": {
		display: "flex",
		alignItems: "center",
	},
});

const fontFamilyStyle = { fontFamily: "Figtree-Regular" };


const ConfirmTabClose = ({
	confirmTabCloseModal,
	handleCloseTab,
}) => {
	const dispatch = useDispatch();

	return (
		<Dialog
			open={confirmTabCloseModal !== null}
			disableEscapeKeyDown
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			className="max-w-[500px] mx-auto"
		>
			<DialogTitle className="!text-size-15"
				id="alert-dialog-title"
				sx={fontFamilyStyle}
			>
				Discard changes and close {confirmTabCloseModal?.options?.title}
			</DialogTitle>
			<DialogContent>
				<Box id="alert-dialog-description" >
					<StyledAlert className="!text-size-11 !mb-[-12px]" severity="warning" sx={fontFamilyStyle}>
						You have unsaved changes that will be lost if you close this tab. Are you sure you want to proceed?
					</StyledAlert>
				</Box>
			</DialogContent>
			<DialogActions>
				<ButtonSecondary
				 className="!text-size-11"
					onClick={() => dispatch(showTabCloseModal(null))}
					sx={fontFamilyStyle}
				>
					No, keep editing
				</ButtonSecondary>
				<ButtonPrimary
				 className="!text-size-11"
					onClick={() => {
						handleCloseTab(confirmTabCloseModal);
						dispatch(showTabCloseModal(null));
					}}
					autoFocus
					sx={fontFamilyStyle}
				>
					Yes, discard changes
				</ButtonPrimary>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmTabClose;
